// Ported from dev-scrips-pm-react src/services/scheduling/use-status-list.ts (PROD-1119 cross-module closure).
import { useQuery } from '@tanstack/react-query';
import { get } from '../api-client';
import type { AppointmentStatus } from '@/types/scheduling-api';

export function useStatusList() {
  return useQuery({
    queryKey: ['appointment-statuses'],
    queryFn: ({ signal }) =>
      get<AppointmentStatus[]>('/api/Appointment/Status?searchText=', { signal }),
  });
}
